var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"order-state d-inline-block text--secondary"},[_c('v-icon',{staticClass:"mr-1 pb-1",attrs:{"color":_vm.color,"size":"8"}},[_vm._v("mdi-circle")]),_vm._v(" "+_vm._s(_vm.$t("orders.state." + _vm.order.state))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }